import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "qgQeVW",
    defaultMessage: "Generate Voucher Codes",
  },
  codeQuantity: {
    id: "vTPu1s",
    defaultMessage: "Code Quantity (max {maxCodes})",
  },
  codePrefix: {
    id: "1UQ9Qy",
    defaultMessage: "Code Prefix (Optional)",
  },
});
